import { render, staticRenderFns } from "./button-inline.vue?vue&type=template&id=0163364d&scoped=true&"
import script from "./button-inline.vue?vue&type=script&lang=js&"
export * from "./button-inline.vue?vue&type=script&lang=js&"
import style0 from "./button-inline.vue?vue&type=style&index=0&id=0163364d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163364d",
  null
  
)

export default component.exports